import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemServiceAddressMaybe = ({ 
  transaction, 
  intl, 
  rootClassName = null, 
  className = null 
}) => {

  // Check if transaction has service address in various possible locations
  const protectedData = transaction?.attributes?.protectedData || {};
  const orderData = transaction?.attributes?.orderData || {};
  const publicData = transaction?.attributes?.publicData || {};
  
  // Look for service address in multiple possible locations
  const serviceAddress = protectedData.serviceAddress || 
                        orderData.serviceAddress || 
                        publicData.serviceAddress ||
                        protectedData.booking?.serviceAddress ||
                        orderData.booking?.serviceAddress;

  if (!serviceAddress || (!serviceAddress.address && !serviceAddress.search)) {
    return null;
  }

  const serviceAddressText = serviceAddress.search || serviceAddress.address || '';

  const classes = className || css.lineItem;
  const rootClasses = rootClassName || css.lineItem;

  return (
    <div className={rootClasses}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.serviceAddress" />
      </span>
      <span className={css.itemValue}>{serviceAddressText}</span>
    </div>
  );
};



LineItemServiceAddressMaybe.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
  transaction: propTypes.transaction.isRequired,
  intl: PropTypes.object.isRequired,
};

export default LineItemServiceAddressMaybe; 